interface Greeting {
  withName: string;
  withoutName: string;
  timeSpecific?: 'morning' | 'afternoon' | 'evening'; // Add time-specific flag
}

export const GREETINGS: Greeting[] = [
  {
    withName: "Hello, {name}!",
    withoutName: "Hello there!"
  },
  {
    withName: "Hey {name}!",
    withoutName: "Hey there!"
  },
  {
    withName: "Welcome back, {name}!",
    withoutName: "Welcome back!"
  },
  {
    withName: "Hi {name}!",
    withoutName: "Hi there!"
  },
  {
    withName: "Good morning, {name}!",
    withoutName: "Good morning!",
    timeSpecific: 'morning'
  },
  {
    withName: "Rise and shine, {name}!",
    withoutName: "Rise and shine!",
    timeSpecific: 'morning'
  },
  {
    withName: "Greetings, {name}!",
    withoutName: "Greetings!"
  },
  {
    withName: "Nice to see you, {name}!",
    withoutName: "Nice to see you!"
  },
  {
    withName: "Welcome, {name}!",
    withoutName: "Welcome!"
  },
  {
    withName: "Good day, {name}!",
    withoutName: "Good day!"
  },
  {
    withName: "Hello again, {name}!",
    withoutName: "Hello again!"
  },
  {
    withName: "Great to see you, {name}!",
    withoutName: "Great to see you!"
  },
  {
    withName: "Good afternoon, {name}!",
    withoutName: "Good afternoon!",
    timeSpecific: 'afternoon'
  },
  {
    withName: "Hope your day is going well, {name}!",
    withoutName: "Hope your day is going well!",
    timeSpecific: 'afternoon'
  },
  {
    withName: "Hey there, {name}!",
    withoutName: "Hey there!"
  },
  {
    withName: "Good evening, {name}!",
    withoutName: "Good evening!",
    timeSpecific: 'evening'
  },
  {
    withName: "Evening, {name}!",
    withoutName: "Evening!",
    timeSpecific: 'evening'
  },
  {
    withName: "Good to have you, {name}!",
    withoutName: "Good to have you!"
  },
  // {
  //   withName: "Wonderful to see you, {name}!",
  //   withoutName: "Wonderful to see you!"
  // },
  // {
  //   withName: "Happy to see you, {name}!",
  //   withoutName: "Happy to see you!"
  // },
  // {
  //   withName: "Glad you're here, {name}!",
  //   withoutName: "Glad you're here!"
  // },
  // {
  //   withName: "Excited to help, {name}!",
  //   withoutName: "Excited to help!"
  // },
  // {
  //   withName: "Ready when you are, {name}!",
  //   withoutName: "Ready when you are!"
  // },
  // {
  //   withName: "At your service, {name}!",
  //   withoutName: "At your service!"
  // },
  // {
  //   withName: "Here to help, {name}!",
  //   withoutName: "Here to help!"
  // },
  // {
  //   withName: "Let's get started, {name}!",
  //   withoutName: "Let's get started!"
  // },
  // {
  //   withName: "Ready to assist, {name}!",
  //   withoutName: "Ready to assist!"
  // },
  // {
  //   withName: "How's it going, {name}?",
  //   withoutName: "How's it going?"
  // },
  {
    withName: "What's up, {name}?",
    withoutName: "What's up?"
  },
  {
    withName: "How are you, {name}?",
    withoutName: "How are you?"
  },
  {
    withName: "Hope you're well, {name}!",
    withoutName: "Hope you're well!"
  },
  {
    withName: "Good to connect, {name}!",
    withoutName: "Good to connect!"
  },
  // {
  //   withName: "Delighted to see you, {name}!",
  //   withoutName: "Delighted to see you!"
  // },
  // {
  //   withName: "Perfect timing, {name}!",
  //   withoutName: "Perfect timing!"
  // },
  // {
  //   withName: "Ready to work, {name}!",
  //   withoutName: "Ready to work!"
  // }
];

// Function to determine current time period based on user's local time
const getCurrentTimePeriod = (): 'morning' | 'afternoon' | 'evening' | 'general' => {
  const now = new Date();
  const hour = now.getHours(); // 0-23

  if (hour >= 5 && hour < 12) {
    return 'morning';
  } else if (hour >= 12 && hour < 18) {
    return 'afternoon';
  } else if (hour >= 18 && hour < 22) {
    return 'evening';
  } else {
    // Late night/early morning hours (10 PM - 5 AM) use general greetings
    return 'general';
  }
};

// Function to get greetings filtered by time appropriateness
const getTimeAppropriateGreetings = (): Greeting[] => {
  const currentPeriod = getCurrentTimePeriod();
  
  if (currentPeriod === 'general') {
    // For late night/early morning, only use non-time-specific greetings
    return GREETINGS.filter(greeting => !greeting.timeSpecific);
  }
  
  // Get time-specific greetings for current period
  const timeSpecificGreetings = GREETINGS.filter(
    greeting => greeting.timeSpecific === currentPeriod
  );
  
  // Get general greetings (non-time-specific)
  const generalGreetings = GREETINGS.filter(greeting => !greeting.timeSpecific);
  
  // Return time-specific greetings first, then general ones
  return [...timeSpecificGreetings, ...generalGreetings];
};

export const getNextGreeting = (userName?: string): string => {
  // Get time-appropriate greetings (time-specific first, then general)
  const availableGreetings = getTimeAppropriateGreetings();
  
  // Get the last used index from localStorage, default to -1 so first call returns index 0
  const lastIndex = parseInt(localStorage.getItem('lastGreetingIndex') || '-1', 10);
  
  // Calculate next index, cycling back to 0 when we reach the end of available greetings
  const nextIndex = (lastIndex + 1) % availableGreetings.length;
  
  // Store the new index for next time
  localStorage.setItem('lastGreetingIndex', nextIndex.toString());
  
  const greeting = availableGreetings[nextIndex];
  
  if (userName) {
    return greeting.withName.replace('{name}', userName);
  }
  
  return greeting.withoutName;
}; 